import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceStreamSettingsNav';
export const useSourceStreamSettingsNavTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    sections: {
      main: 'Основные параметры',
    },
    va_group: 'Видеоаналитики',
    add_analytics: 'Добавить',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    sections: {
      main: 'Basic parameters',
    },
    va_group: 'Video analytics',
    add_analytics: 'Add',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    sections: {
      main: 'Parámetros básicos',
    },
    va_group: 'Videoanalíticas',
    add_analytics: 'Añadir',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    sections: {
      main: 'Parâmetros básicos',
    },
    va_group: 'Videoanalíticas',
    add_analytics: 'Adicionar',
  },
}) as Record<string, unknown>;
